import { computed } from "vue";
import type { AlertProps } from "./alert.types";
import { alertGridClasses } from "./alert.styles";
import { cardClasses } from "components/Card/card.styles";

/**
 * Computes class strings for `<e-alert>`.
 *
 * `hasIcon` trims `props.icon` so the boolean-attribute form (`<e-alert icon="">`)
 * and whitespace-only strings don't activate the two-column grid.
 */
export const useAlert = (props: Readonly<AlertProps>) => {
  const hasIcon = computed(() => Boolean(props.icon?.trim()));
  const cardCls = computed(() => cardClasses({ color: props.color, variant: props.variant, size: "xs" }));

  const classes = computed(() => ({
    grid: `${alertGridClasses.base} ${hasIcon.value ? alertGridClasses.withIcon : alertGridClasses.withoutIcon}`,
    header: hasIcon.value ? alertGridClasses.header : "",
    body: hasIcon.value ? alertGridClasses.body : "",
    actions: hasIcon.value ? alertGridClasses.actions : "",
  }));

  return { hasIcon, cardCls, classes };
};
